import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    PERMISSION_STATE_FEATURE_KEY,
    PermissionState,
} from './permission-state.model';

const getPermissionState = createFeatureSelector<PermissionState>(PERMISSION_STATE_FEATURE_KEY);

export const pagePermissionsSelector = createSelector(
    getPermissionState,
    (state) => state.pagePermissions,
);

export const errorSelector = createSelector(
    getPermissionState,
    (state) => state.error,
);
